import { animate, useAnimation, motion } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import { useInView } from "react-intersection-observer";
import { box, container } from "../data/anim";
import "react-icons/fa";
import {
  FaCss3,
  FaGit,
  FaGithub,
  FaHtml5,
  FaNodeJs,
  FaReact,
  FaSass,
} from "react-icons/fa";

import { DiMongodb } from "react-icons/di";
import "react-icons/si";
import {
  SiJavascript,
  SiJsonwebtokens,
  SiRedux,
  SiSocketdotio,
} from "react-icons/si";
const Skills = () => {
  const refCont = useRef(null);
  const refCont1 = useRef(null);
  const { ref, inView } = useInView({
    threshold: 0.1,
  });
  const animation = useAnimation();
  const animation2 = useAnimation();

  useEffect(() => {
    // const ref = refCont.current;
    // const ref1 = refCont1.current;

    if (inView) {
      animation.start({
        scale: 1,
        transition: {
          type: "spring",
          duration: 1,
          bounce: 0.3,
        },
      });
      animation2.start({
        scale: 0,
      });
    } else {
      animation.start({
        scale: 0,
      });
    }
  }, [inView, animation]);
  return (
    <motion.div ref={ref} className="title-container">
      <motion.h2 className="title" animate={animation}>
        My current skillset
      </motion.h2>

      <div className="skill-list-container">
        {inView && (
          <motion.ul
            variants={container}
            initial="hidden"
            animate="visible"
            className="skill-ul"
          >
            <motion.li variants={box} className="skill-list">
              <SiJavascript style={{ color: "#EED81C", fontSize: "5rem" }} />
              <span className="tool">Javascript</span>
            </motion.li>
            <motion.li variants={box} className="skill-list">
              <FaHtml5 style={{ color: "#DF4716", fontSize: "5rem" }} />
              <span className="tool">HTML</span>
            </motion.li>
            <motion.li variants={box} className="skill-list">
              <FaCss3 style={{ color: "#2194F0", fontSize: "5rem" }} />
              <span className="tool">CSS</span>
            </motion.li>
            <motion.li variants={box} className="skill-list">
              <FaSass style={{ color: "#C96195", fontSize: "5rem" }} />
              <span className="tool">Sass</span>
            </motion.li>
            <motion.li variants={box} className="skill-list">
              <FaReact style={{ color: "#50BBD7", fontSize: "5rem" }} />
              <span className="tool">React</span>
            </motion.li>
            <motion.li variants={box} className="skill-list">
              <SiRedux style={{ color: "#7348B7", fontSize: "5rem" }} />
              <span className="tool">Redux</span>
            </motion.li>
            <motion.li variants={box} className="skill-list">
              <DiMongodb style={{ color: "#87D144", fontSize: "5rem" }} />
              <span className="tool">MongoDB</span>
            </motion.li>
            <motion.li variants={box} className="skill-list">
              <FaNodeJs style={{ color: "#88C249", fontSize: "5rem" }} />
              <span className="tool">NodeJS</span>
            </motion.li>
            <motion.li variants={box} className="skill-list">
              <FaGit style={{ color: "#E94F30", fontSize: "5rem" }} />
              <span className="tool">Git</span>
            </motion.li>
            <motion.li variants={box} className="skill-list">
              <FaGithub style={{ color: "#000000", fontSize: "5rem" }} />
              <span className="tool">Github</span>
            </motion.li>
            <motion.li variants={box} className="skill-list">
              <SiJsonwebtokens style={{ color: "#CE38F6", fontSize: "5rem" }} />
              <span className="tool">JWT</span>
            </motion.li>
            <motion.li variants={box} className="skill-list">
              <SiSocketdotio style={{ color: "#000100", fontSize: "5rem" }} />
              <span className="tool">Socket.IO</span>
            </motion.li>
          </motion.ul>
        )}
      </div>

      {/* <div ref={ref} className="achievements">
        <div className="achievement1">
          <span>Cup of coffee: </span>
          <span ref={refCont}></span>
          <span ref={refCont1}></span>
        </div>
      </div> */}
    </motion.div>
  );
};

export default Skills;
